module.exports = __webpack_public_path__ + "img/user.056fe889.svg";